var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown18Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A2B3B8",
    fillRule: "evenodd",
    d: "M14.63 6.998c.231.225.37.54.37.81 0 .315-.093.585-.324.81-.463.45-1.203.45-1.666 0l-5.277-5.04-5.23 5.085c-.463.45-1.204.45-1.666 0a1.118 1.118 0 010-1.62L6.9 1.193a1.156 1.156 0 011.666-.046l6.064 5.85z",
    opacity: 0.8
  })));
}
export default SvgDropdown18Px;